module.exports = __webpack_public_path__ + "img/menu-sheying-active.948e6ad6.svg";